import React from 'react';
import PropTypes from 'prop-types';
import createEmotionStyled from 'create-emotion-styled';
import createEmotion from 'create-emotion';
var context = typeof global !== 'undefined' ? global : {};

var _createEmotion = createEmotion(context, {
  nonce: btoa('web-ui-components')
}),
    caches = _createEmotion.caches,
    css = _createEmotion.css,
    cx = _createEmotion.cx,
    flush = _createEmotion.flush,
    getRegisteredStyles = _createEmotion.getRegisteredStyles,
    hydrate = _createEmotion.hydrate,
    injectGlobal = _createEmotion.injectGlobal,
    keyframes = _createEmotion.keyframes,
    merge = _createEmotion.merge,
    sheet = _createEmotion.sheet;

var emotion = /*#__PURE__*/Object.freeze({
  __proto__: null,
  caches: caches,
  css: css,
  cx: cx,
  flush: flush,
  getRegisteredStyles: getRegisteredStyles,
  hydrate: hydrate,
  injectGlobal: injectGlobal,
  keyframes: keyframes,
  merge: merge,
  sheet: sheet
});
var styled = createEmotionStyled(emotion, React);
var breakpoints = {
  xs1: '0',
  xs2: '480px',
  sm1: '540px',
  sm2: '640px',
  md1: '768px',
  md2: '960px',
  lg1: '1024px',
  lg2: '1280px',
  lg3: '1328px',
  xl1: '1420px',
  xl2: '1920px'
};

var getMediaQuery = function getMediaQuery(css, breakpoint) {
  return '@media (min-width: ' + breakpoint + ') { ' + css + ' }';
};

var breakpointAndUp = {};

var _loop = function _loop(_breakpoint2) {
  if (breakpoints[_breakpoint2] !== '0') {
    breakpointAndUp[_breakpoint2] = function (css) {
      return getMediaQuery(css, breakpoints[_breakpoint2]);
    };
  }
};

for (var _breakpoint2 in breakpoints) {
  _loop(_breakpoint2);
}

var theme = {
  baseFontSize: 16
}; //DEBTxCYBG pull this from theme component or global?

var baseSpacing = 8;

var spacingHelper = function spacingHelper(value) {
  var fontMultiple = value * baseSpacing;
  var rems = fontMultiple / theme.baseFontSize;
  return rems + 'rem';
};

var spacing = {
  EIGHTH: spacingHelper(0.125),
  QUARTER: spacingHelper(0.25),
  HALF: spacingHelper(0.5),
  THREE_QUARTERS: spacingHelper(0.75),
  SINGLE: spacingHelper(1),
  ONE_AND_QUARTER: spacingHelper(1.25),
  ONE_AND_HALF: spacingHelper(1.5),
  ONE_AND_THREE_QUARTERS: spacingHelper(1.75),
  DOUBLE: spacingHelper(2),
  TWO_AND_HALF: spacingHelper(2.5),
  TRIPLE: spacingHelper(3),
  THREE_AND_HALF: spacingHelper(3.5),
  QUADRUPLE: spacingHelper(4),
  QUINTUPLE: spacingHelper(5),
  SEXTUPLE: spacingHelper(6),
  SEPTUPLE: spacingHelper(7),
  OCTUPLE: spacingHelper(8),
  NONUPLE: spacingHelper(9),
  DECUPLE: spacingHelper(10)
};
var internalPaddingShell = '\n    overflow: auto;\n    padding-bottom: ' + spacing.SINGLE + '; \n    padding-left: ' + spacing.DOUBLE + '; \n    padding-right: 0; \n    padding-top: ' + spacing.DOUBLE + ';\n    ' + breakpointAndUp.md1('\n        padding-left: ' + spacing.TRIPLE + ';\n        padding-right: ' + spacing.SINGLE + ';\n    ') + '\n';
/* Font size config: usage example ${fontSize('arran')} */

var fontConfig = {
  lewis: {
    xs1: {
      fontSize: 37,
      lineHeight: 1.189
    },
    sm1: {
      fontSize: 37,
      lineHeight: 1.189
    },
    md1: {
      fontSize: 45,
      lineHeight: 1.067
    },
    lg1: {
      fontSize: 52,
      lineHeight: 1.154
    },
    xl1: {
      fontSize: 52,
      lineHeight: 1.154
    }
  },
  skye: {
    xs1: {
      fontSize: 32,
      lineHeight: 1.125
    },
    sm1: {
      fontSize: 32,
      lineHeight: 1.125
    },
    md1: {
      fontSize: 40,
      lineHeight: 1.1
    },
    lg1: {
      fontSize: 45,
      lineHeight: 1.156
    },
    xl1: {
      fontSize: 45,
      lineHeight: 1.156
    }
  },
  shetland: {
    xs1: {
      fontSize: 29,
      lineHeight: 1.241
    },
    sm1: {
      fontSize: 29,
      lineHeight: 1.241
    },
    md1: {
      fontSize: 34,
      lineHeight: 1.176
    },
    lg1: {
      fontSize: 39,
      lineHeight: 1.128
    },
    xl1: {
      fontSize: 39,
      lineHeight: 1.128
    }
  },
  mull: {
    xs1: {
      fontSize: 26,
      lineHeight: 1.231
    },
    sm1: {
      fontSize: 26,
      lineHeight: 1.231
    },
    md1: {
      fontSize: 29,
      lineHeight: 1.241
    },
    lg1: {
      fontSize: 33,
      lineHeight: 1.212
    },
    xl1: {
      fontSize: 33,
      lineHeight: 1.212
    }
  },
  islay: {
    xs1: {
      fontSize: 23,
      lineHeight: 1.217
    },
    sm1: {
      fontSize: 23,
      lineHeight: 1.217
    },
    md1: {
      fontSize: 25,
      lineHeight: 1.28
    },
    lg1: {
      fontSize: 28,
      lineHeight: 1.286
    },
    xl1: {
      fontSize: 28,
      lineHeight: 1.286
    }
  },
  orkney: {
    xs1: {
      fontSize: 20,
      lineHeight: 1.4
    },
    sm1: {
      fontSize: 20,
      lineHeight: 1.4
    },
    md1: {
      fontSize: 22,
      lineHeight: 1.273
    },
    lg1: {
      fontSize: 25,
      lineHeight: 1.28
    },
    xl1: {
      fontSize: 25,
      lineHeight: 1.28
    }
  },
  arran: {
    xs1: {
      fontSize: 18,
      lineHeight: 1.333
    },
    sm1: {
      fontSize: 18,
      lineHeight: 1.333
    },
    md1: {
      fontSize: 19,
      lineHeight: 1.474
    },
    lg1: {
      fontSize: 21,
      lineHeight: 1.333
    },
    xl1: {
      fontSize: 21,
      lineHeight: 1.333
    }
  },
  jura: {
    xs1: {
      fontSize: 16,
      lineHeight: 1.5
    },
    sm1: {
      fontSize: 16,
      lineHeight: 1.5
    },
    md1: {
      fontSize: 16,
      lineHeight: 1.5
    },
    lg1: {
      fontSize: 18,
      lineHeight: 1.556
    },
    xl1: {
      fontSize: 18,
      lineHeight: 1.556
    }
  },
  uist: {
    xs1: {
      fontSize: 14,
      lineHeight: 1.429
    },
    sm1: {
      fontSize: 14,
      lineHeight: 1.429
    },
    md1: {
      fontSize: 14,
      lineHeight: 1.429
    },
    lg1: {
      fontSize: 16,
      lineHeight: 1.5
    },
    xl1: {
      fontSize: 16,
      lineHeight: 1.5
    }
  },
  bute: {
    xs1: {
      fontSize: 12,
      lineHeight: 1.333
    },
    sm1: {
      fontSize: 12,
      lineHeight: 1.333
    },
    md1: {
      fontSize: 13,
      lineHeight: 1.538
    },
    lg1: {
      fontSize: 13,
      lineHeight: 1.538
    },
    xl1: {
      fontSize: 13,
      lineHeight: 1.538
    }
  },
  cumbrae: {
    xs1: {
      fontSize: 11,
      lineHeight: 1.455
    },
    sm1: {
      fontSize: 11,
      lineHeight: 1.455
    },
    md1: {
      fontSize: 12,
      lineHeight: 1.333
    },
    lg1: {
      fontSize: 12,
      lineHeight: 1.333
    },
    xl1: {
      fontSize: 12,
      lineHeight: 1.333
    }
  }
};

var generateSASS = function generateSASS(mqBreakpoint, size, lineHeight) {
  var styles = '';

  if (parseInt(mqBreakpoint) === 0) {
    styles = 'font-size: ' + size + 'px; line-height: ' + lineHeight + ';';
  } else {
    styles = '\n      @media (min-width: ' + mqBreakpoint + ') {\n        font-size: ' + size + 'px;\n        line-height: ' + lineHeight + ';\n      } \n    ';
  }

  return styles;
};

var fontSizes = {};

for (var _fontSize in fontConfig) {
  if (fontConfig.hasOwnProperty(_fontSize)) {
    var style = '';

    for (var breakpoint in fontConfig[_fontSize]) {
      if (fontConfig[_fontSize].hasOwnProperty(breakpoint)) {
        var _fontConfig$_fontSize = fontConfig[_fontSize][breakpoint],
            size = _fontConfig$_fontSize.fontSize,
            lineHeight = _fontConfig$_fontSize.lineHeight;
        style += generateSASS(breakpoints[breakpoint], size, lineHeight);
      }
    }

    fontSizes[_fontSize] = style;
  }
}

var fontSize = function fontSize(font) {
  return fontSizes[font];
};

var taggedTemplateLiteral = function taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var _templateObject = taggedTemplateLiteral(['\n\t', '\n\tfont-family: ', ';\n\t', ';\n\t', ';\n'], ['\n\t', '\n\tfont-family: ', ';\n\t', ';\n\t', ';\n']);

var getFontProperties = function getFontProperties(props) {
  var fontProperties = 'font-size: 16px; line-height: 1.5;'; // TODOxCYBG To be revisited with responsive VM typography.
  // if (props.theme.name !== 'vm') {

  fontProperties = props.theme.isCompact ? fontSize('uist') : fontSize('jura'); // }

  return fontProperties;
};

var StyledStandardLabel = styled('div')(_templateObject, getFontProperties, function (props) {
  return props.theme.fonts.standardLabel;
}, function (props) {
  return !props.isFlush && 'margin-bottom: ' + spacing.DOUBLE;
}, function (props) {
  return !props.isFlush && 'margin-right: ' + spacing.DOUBLE;
});

var StandardLabel = function StandardLabel(_ref) {
  var isFlush = _ref.isFlush,
      children = _ref.children;
  return React.createElement(StyledStandardLabel, {
    isFlush: isFlush
  }, children);
};

StandardLabel.propTypes = {
  /** Allows for content to be text or node (for example IconTextDynamic). */
  children: PropTypes.node.isRequired,

  /** Removed margins. */
  isFlush: PropTypes.bool
};
StandardLabel.defaultProps = {
  isFlush: false
};

var _templateObject$1 = taggedTemplateLiteral(['\n\t', '\n\tfont-family: ', ';\n\t', ';\n\t', ';\n'], ['\n\t', '\n\tfont-family: ', ';\n\t', ';\n\t', ';\n']);

var getFontProperties$1 = function getFontProperties(props) {
  var fontProperties = 'font-size: 14px; line-height: 1.4286;'; // TODOxCYBG To be revisited with responsive VM typography.
  // if (props.theme.name !== 'vm') {

  fontProperties = props.theme.isCompact ? fontSize('cumbrae') : fontSize('bute'); // }

  return fontProperties;
};

var StyledSubLabel = styled('div')(_templateObject$1, getFontProperties$1, function (props) {
  return props.theme.fonts.subLabel;
}, function (props) {
  return !props.isFlush && 'margin-bottom: ' + spacing.DOUBLE;
}, function (props) {
  return !props.isFlush && 'margin-right: ' + spacing.DOUBLE;
});

var SubLabel = function SubLabel(_ref) {
  var isFlush = _ref.isFlush,
      children = _ref.children;
  return React.createElement(StyledSubLabel, {
    isFlush: isFlush
  }, children);
};

SubLabel.propTypes = {
  /** Allows for content to be text or node (for example IconTextDynamic). */
  children: PropTypes.node.isRequired,

  /** Removed margins. */
  isFlush: PropTypes.bool
};
SubLabel.defaultProps = {
  isFlush: false
};

SubLabel.defaultExample = function () {
  return React.createElement(SubLabel, null, 'SubLabel');
};

var _templateObject$2 = taggedTemplateLiteral(['\n\t', '\n\tfont-family: ', ';\n\t', ';\n\t', ';\n\tdisplay: inline-block;\n'], ['\n\t', '\n\tfont-family: ', ';\n\t', ';\n\t', ';\n\tdisplay: inline-block;\n']);

var getFontProperties$2 = function getFontProperties(props) {
  var fontProperties = 'font-size: 16px; line-height: 1.5;'; // TODOxCYBG To be revisited with responsive VM typography.
  // if (props.theme.name !== 'vm') {

  fontProperties = props.theme.isCompact ? fontSize('uist') : fontSize('arran'); // }

  return fontProperties;
};

var StyledFieldLabel = styled('label')(_templateObject$2, getFontProperties$2, function (props) {
  return props.theme.fonts.fieldLabel;
}, function (props) {
  return !props.isFlush && 'margin-bottom: ' + spacing.DOUBLE;
}, function (props) {
  return !props.isFlush && 'margin-right: ' + spacing.DOUBLE;
});

var FieldLabel = function FieldLabel(_ref) {
  var htmlFor = _ref.htmlFor,
      form = _ref.form,
      isFlush = _ref.isFlush,
      children = _ref.children;
  return React.createElement(StyledFieldLabel, {
    htmlFor: htmlFor,
    form: form,
    isFlush: isFlush
  }, children);
};

FieldLabel.propTypes = {
  /** Allows for content to be text or node (for example IconTextDynamic). */
  children: PropTypes.node.isRequired,

  /** Removed margins. */
  isFlush: PropTypes.bool,

  /** For attribute to connect with input. */
  htmlFor: PropTypes.string.isRequired,

  /** The form element with which the label is associated. */
  form: PropTypes.string
};
FieldLabel.defaultProps = {
  isFlush: false
};

var _templateObject$3 = taggedTemplateLiteral(['\n\t', '\n\tfont-family: ', ';\n\t', ';\n\t', ';\n'], ['\n\t', '\n\tfont-family: ', ';\n\t', ';\n\t', ';\n']);

var getFontProperties$3 = function getFontProperties(props) {
  var fontProperties = 'font-size: 20px; line-height: 1.3;'; // TODOxCYBG To be revisited with responsive VM typography.
  // if (props.theme.name !== 'vm') {

  fontProperties = props.theme.isCompact ? fontSize('jura') : fontSize('arran'); // }

  return fontProperties;
};

var StyledProminentLabel = styled('div')(_templateObject$3, getFontProperties$3, function (props) {
  return props.theme.fonts.display.bold;
}, function (props) {
  return !props.isFlush && 'margin-bottom: ' + spacing.DOUBLE;
}, function (props) {
  return !props.isFlush && 'margin-right: ' + spacing.DOUBLE;
});

var ProminentLabel = function ProminentLabel(_ref) {
  var isFlush = _ref.isFlush,
      children = _ref.children;
  return React.createElement(StyledProminentLabel, {
    isFlush: isFlush
  }, children);
};

ProminentLabel.propTypes = {
  /** Allows for content to be text or node (for example IconTextDynamic). */
  children: PropTypes.node.isRequired,

  /** Removed margins. */
  isFlush: PropTypes.bool
};
ProminentLabel.defaultProps = {
  isFlush: false
};
export { FieldLabel, ProminentLabel, StandardLabel, SubLabel };